import { seaTurtleApiAreaCodeGetDefaultPost } from '@/services/api/CommonApi'

export const DEFAULT_AREA_CODE = '86'
export const DEFAULT_COUNTRY_CODE = 'CN'

export async function getSiteDefaultAreaConfig() {
  try {
    const res = await seaTurtleApiAreaCodeGetDefaultPost({}, {
      responseOnlyBody: false,
    })

    const areaCode = `${Number(res?.body?.defaultAreaCode || '')}` || DEFAULT_AREA_CODE
    const countryCode = res?.body?.defaultCountryCode || DEFAULT_COUNTRY_CODE

    return {
      areaCode,
      countryCode,
    }
  }
  catch (error) {
    return {
      areaCode: DEFAULT_AREA_CODE,
      countryCode: DEFAULT_COUNTRY_CODE,
    }
  }
}

export async function getSiteDefaultAreaCode() {
  const config = await getSiteDefaultAreaConfig()
  return config.areaCode
}
